"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactMintl = require("@godaddy/react-mintl");
var _enums = require("./enums");
var _golfToEid = _interopRequireDefault(require("golf-to-eid"));
var _link = _interopRequireDefault(require("@ux/link"));
var _linkArrow = _interopRequireDefault(require("@ux/icon/link-arrow"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
class ChildPanel extends _react.Component {
  constructor() {
    super(...arguments);
    this.focusables = [];
    this.state = _objectSpread(_objectSpread({}, this.state), {}, {
      hovered: false
    });
    this.createFocusRefs = this.createFocusRefs.bind(this);
    this.focusFirst = this.focusFirst.bind(this);
    this.focusNext = this.focusNext.bind(this);
    this.focusPrevious = this.focusPrevious.bind(this);
  }

  /**
   * Focus on close button first
   * @private
   */
  focusFirst() {
    this.props.setFocusToClose();
  }

  /**
   * Focus on the next link in the shown panel or move focus to close button when appropriate
   * @private
   */
  focusNext() {
    if (this.focusables.length < 1) return;
    if (1 + this.focusables.indexOf(document.activeElement) === this.focusables.length) {
      this.props.setFocusToClose();
    } else {
      const newIndex = (1 + this.focusables.indexOf(document.activeElement)) % this.focusables.length;
      this.focusables[newIndex].focus();
    }
  }

  /**
   * Focus on the previous link in the shown panel or move focus to close button when appropriate
   * @private
   */
  focusPrevious() {
    const len = this.focusables.length;
    if (this.focusables.indexOf(document.activeElement) === 0) {
      this.props.setFocusToClose();
    } else if (this.focusables.indexOf(document.activeElement) < 0 /* -1 == not found */) {
      const newIndex = len - 1;
      this.focusables[newIndex].focus();
    } else {
      const newIndex = (len - 1 + this.focusables.indexOf(document.activeElement)) % len;
      this.focusables[newIndex].focus();
    }
  }

  /**
   * Store refs to focusable nav items
   * @private
   * @param {HTMLElement} btn DOM node to be stored in ref
   */
  createFocusRefs(btn) {
    if (btn && btn.anchor) {
      this.focusables.push(btn.anchor.current);
    } else {
      this.focusables.push(btn);
    }
  }

  /**
   * render a back button
   *
   * @private
   * @returns {React.ReactElement} a div with a back btn
   */
  renderBackBtn() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "child-flyout-back"
    }, /*#__PURE__*/_react.default.createElement("button", {
      tabIndex: this.props.tabIndex,
      ref: this.createFocusRefs,
      onClick: this.props.onBack,
      className: "child-flyout-back-btn"
    }, /*#__PURE__*/_react.default.createElement(_linkArrow.default, {
      "aria-hidden": "true"
    }), /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf.mainMenu
    })));
  }

  /**
   * Renders the heading at the top of the child panel
   * @param  {String} title The text to render
   * @param  {String} href The destination for the link
   * @param  {Object} urlArgs Args to append to the href
   * @returns {React.ReactElement} `Link` component or span with literal string
   */
  renderTitle(title, href, urlArgs) {
    if (typeof href === 'string' && href.length) {
      return /*#__PURE__*/_react.default.createElement(_link.default, {
        href: href,
        urlArgs: urlArgs,
        tabIndex: this.props.tabIndex,
        className: "title-no-link-styling"
      }, /*#__PURE__*/_react.default.createElement("span", null, title));
    }
    return /*#__PURE__*/_react.default.createElement("span", null, title);
  }
  renderLearnMoreButton() {
    const props = this.props;
    const {
      leftnav = {}
    } = props.parent;
    const {
      href,
      btn,
      btnText,
      id
    } = leftnav;
    const buttonText = btn || btnText;
    if (href && buttonText) {
      return /*#__PURE__*/_react.default.createElement(_link.default, {
        className: "learn-more",
        href: href,
        rel: "nofollow",
        onClicked: props.onClose,
        urlArgs: props.urlArgs,
        tabIndex: props.tabIndex,
        "data-eid": (0, _golfToEid.default)(btn || id, {
          prefix: props.eidPrefix,
          postfix: 'link.click'
        })
      }, /*#__PURE__*/_react.default.createElement("span", null, buttonText));
    }
  }

  /**
   * Renders panel title, description, and learn more btn if present
   * @returns {React.ReactElement} Div for title/description/learnmore
   */
  renderTitleAndDescription() {
    const props = this.props;
    const {
      leftnav = {},
      title
    } = props.parent;
    const description = leftnav.description || leftnav.descriptionText;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "child-panel-top-info"
    }, title && /*#__PURE__*/_react.default.createElement("div", {
      className: "product-flyout-heading",
      role: "heading",
      "aria-level": "2"
    }, this.renderTitle(title, leftnav.href, props.urlArgs)), description && /*#__PURE__*/_react.default.createElement("p", {
      className: "description"
    }, /*#__PURE__*/_react.default.createElement("span", null, description), ' ', this.renderLearnMoreButton()));
  }

  /**
   * Generate links
   *
   * @private
   * @param {Object[]} items Array of objects to display as links
   * @returns {React.ReactElement[]} a set of Links
   */
  renderLinks(items) {
    const props = this.props;
    const links = [];
    items.forEach(child => {
      if (child.onlyallproducts) {
        return;
      }
      const {
        title,
        id,
        href
      } = child;
      if (href && href.length && title) {
        let eid;
        if (id) {
          eid = (0, _golfToEid.default)(id, {
            prefix: props.eidPrefix,
            postfix: 'link.click'
          });
        }
        links.push( /*#__PURE__*/_react.default.createElement("li", {
          key: id,
          className: "child-menu-link"
        }, /*#__PURE__*/_react.default.createElement(_link.default, {
          "data-eid": eid,
          href: href,
          urlArgs: props.urlArgs,
          onClicked: props.onClose,
          tabIndex: props.tabIndex,
          ref: this.createFocusRefs,
          onMouseEnter: () => this.setState({
            hovered: true
          }),
          onMouseLeave: () => this.setState({
            hovered: false
          })
        }, /*#__PURE__*/_react.default.createElement("span", null, title), /*#__PURE__*/_react.default.createElement(_linkArrow.default, {
          "aria-hidden": "true"
        }))));
      }
    });
    return links;
  }

  /**
   * Renders a group of links that may or may not have a heading
   * @private
   * @param {Object[]} sections Array of objects for generating the sections of links
   * @returns {React.ReactElement[]} a set of list items
   */
  renderSections(sections) {
    const props = this.props;
    const subNavSections = [];
    sections.forEach(section => {
      const {
        title,
        children
      } = section;
      if (Array.isArray(children) && children.length > 0 && !section.onlyallproducts) {
        const showSectionHeader = title !== props.parent.title;
        subNavSections.push( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
          key: section.id
        }, showSectionHeader && /*#__PURE__*/_react.default.createElement("div", {
          className: "child-menu-header"
        }, /*#__PURE__*/_react.default.createElement("span", null, title)), /*#__PURE__*/_react.default.createElement("ul", {
          className: "child-menu-links"
        }, this.renderLinks(children))));
      }
    });
    if (subNavSections.length === 0) {
      // no subNavSections, just a list of links
      return this.renderLinks(sections);
    }
    return subNavSections;
  }

  /**
   * Render panel displaying subnav if navigation menu is open
   *
   * @private
   *
   * @returns {React.ReactElement} div for the subnav panel
   */
  render() {
    const {
      props,
      state
    } = this;
    return /*#__PURE__*/_react.default.createElement("div", {
      onTransitionEnd: e => props.open && e.propertyName === 'transform' && this.focusFirst(),
      className: (0, _classnames.default)(props.className, 'child-menu-panel', props.open && 'open', props.open && state.hovered && 'product-flyout-hovered-menu')
    }, this.renderBackBtn(), /*#__PURE__*/_react.default.createElement("div", {
      className: "child-menu-container menu-scroller",
      onScroll: this.props.onScroll,
      ref: r => {
        this.outerDiv = r;
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      ref: r => {
        this.innerDiv = r;
      }
    }, this.renderTitleAndDescription(), /*#__PURE__*/_react.default.createElement("div", {
      className: "child-menu-items-row"
    }, this.renderSections(props.navigation).map((frag, j) => {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: j,
        className: "child-menu-items-col"
      }, frag);
    })))));
  }
}

/**
 * PropType validation for SubNavPanel
 *
 * @type {Object}
 * @api public
 */
ChildPanel.propTypes = {
  className: _propTypes.default.string,
  eidPrefix: _propTypes.default.string,
  messages: _propTypes.default.object,
  navigation: _propTypes.default.array.isRequired,
  onBack: _propTypes.default.func,
  onClose: _propTypes.default.func,
  onScroll: _propTypes.default.func,
  open: _propTypes.default.bool,
  parent: _propTypes.default.object.isRequired,
  tabIndex: _propTypes.default.number,
  urlArgs: _propTypes.default.object,
  setFocusToClose: _propTypes.default.func
};

/**
 * Default property values.
 *
 * @type {Object}
 * @public
 */
ChildPanel.defaultProps = {
  onBack: () => {},
  onClose: () => {},
  open: false
};
var _default = ChildPanel;
exports.default = _default;